import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'radio',
    'confirmButton'
  ];

  toggleRadio() {
    this.confirmButtonTarget.disabled = this.radioTargets.every(radio => !radio.checked);
  }
}
